import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styles from "./user-profile.module.css";
import { useContext, useState, useEffect } from "react";
import { UserIcon } from "../../../assets/user-icon";
import { SharedUiHeaderV2Context } from "../../context/context-shared-ui-header-v2";
import { Favourites } from "../favourites/favourites";
import { BasketNavigation } from "../basket-navigation/basket-navigation";
export var UserProfile = function(param) {
    var checkoutModal = param.checkoutModal, shouldShowBasketIcon = param.shouldShowBasketIcon;
    var ref = useContext(SharedUiHeaderV2Context), logicStore = ref.logicStore, userStore = ref.userStore;
    var ref1 = useState(false), isDesktop = ref1[0], setIsDesktop = ref1[1];
    var handleTrackEvent = logicStore.handleTrackEvent, isCheckoutModalVisible = logicStore.isCheckoutModalVisible;
    var firstName = userStore.firstName, isLoggedIn = userStore.isLoggedIn;
    useEffect(function() {
        if ("object" !== "undefined") {
            setIsDesktop((window === null || window === void 0 ? void 0 : window.innerWidth) >= 767);
        }
    });
    return /*#__PURE__*/ _jsxs("li", {
        className: styles.userProfileWrapper,
        children: [
            /*#__PURE__*/ _jsxs("a", {
                className: styles.profileLink,
                href: "/my-profile",
                "aria-label": "my profile",
                onClick: function() {
                    handleTrackEvent({
                        name: "click",
                        category: "mega menu",
                        label: "my profile",
                        action: "button"
                    });
                },
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: styles.profileLinkText,
                        "data-dd-privacy": "mask",
                        children: firstName ? "Hi ".concat(firstName, "!") : "My Profile"
                    }),
                    /*#__PURE__*/ _jsx(UserIcon, {})
                ]
            }),
            isLoggedIn ? /*#__PURE__*/ _jsx(Favourites, {}) : null,
            isDesktop && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(BasketNavigation, {
                        checkoutModalAvailable: !!checkoutModal,
                        shouldShowBasketIcon: shouldShowBasketIcon
                    }),
                    isCheckoutModalVisible && checkoutModal
                ]
            })
        ]
    });
};
